import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyCustomerEmail } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: Boolean(token), verified: false, error: token ? "" : "The verification token is missing." });
  useEffect(() => {
    if (!token) return;
    verifyCustomerEmail(token)
      .then(() => setState({ loading: false, verified: true, error: "" }))
      .catch((error) => setState({ loading: false, verified: false, error: error.response?.data?.detail || "This verification link is invalid or expired." }));
  }, [token]);
  return <div className="min-h-[70vh] bg-slate-50 px-4 py-16"><div className="mx-auto max-w-md rounded-2xl border bg-white p-8 text-center shadow-sm">
    <h1 className="text-2xl font-bold">Email verification</h1>
    {state.loading && <p className="mt-5 text-sm text-slate-600">Verifying…</p>}
    {state.verified && <p className="mt-5 text-sm text-emerald-700">Your email address is verified.</p>}
    {state.error && <p className="mt-5 text-sm text-rose-600">{state.error}</p>}
    <Link to="/account/dashboard" className="mt-6 inline-block font-semibold text-emerald-600">Open my account</Link>
  </div></div>;
}
